import type { Area } from 'react-easy-crop';

const OUTPUT_W = 1080;
const OUTPUT_H = 1920;

function loadImage(src: string): Promise<globalThis.HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new globalThis.Image();
    img.crossOrigin = 'anonymous';
    img.onload = (): void => resolve(img);
    img.onerror = (): void => reject(new Error('image load failed'));
    img.src = src;
  });
}

function toBlob(
  canvas: globalThis.HTMLCanvasElement
): Promise<globalThis.Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('canvas toBlob failed'))),
      'image/jpeg',
      0.92
    );
  });
}

export async function renderCroppedBlob(
  src: string,
  area: Area
): Promise<globalThis.Blob> {
  const img = await loadImage(src);
  const canvas = document.createElement('canvas');
  canvas.width = OUTPUT_W;
  canvas.height = OUTPUT_H;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas 2d context unavailable');
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, OUTPUT_W, OUTPUT_H);
  ctx.drawImage(
    img,
    area.x,
    area.y,
    area.width,
    area.height,
    0,
    0,
    OUTPUT_W,
    OUTPUT_H
  );
  return toBlob(canvas);
}

export function blobToFile(
  blob: globalThis.Blob,
  name: string
): globalThis.File {
  return new globalThis.File([blob], name, {
    type: blob.type || 'image/jpeg',
  });
}
